import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-20 md:py-24 px-6 bg-navy text-white relative overflow-hidden" data-id="element-55">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-56"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-57"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-58">
        <FadeIn data-id="element-59">
          <span className="text-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-60">
            El Mecanismo Único
          </span>
          <h2 className="font-serif text-3xl md:text-4xl mb-8" data-id="element-61">
            El Ciclo de Encendido Somático (Protocolo CES)
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-62">
          <div className="space-y-6 text-lg text-white/80 leading-relaxed" data-id="element-63">
            <p data-id="element-64">
              En lugar de forzar tu mente, hablamos directamente a tu sistema
              nervioso. A través de micropasos de "Inercia Cero" y declaraciones
              bíblicas de identidad, reactivamos los cables entre tu cerebro y
              tus músculos.
            </p>
            <p data-id="element-65">
              Es un encendido suave que respeta tu dolor mientras te devuelve la
              movilidad. No necesitas energía para empezar; el método genera el
              primer impulso por ti.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}